import { render, staticRenderFns } from "./billing-info.vue?vue&type=template&id=45b34a08"
import script from "./billing-info.vue?vue&type=script&lang=js"
export * from "./billing-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports